// extracted by mini-css-extract-plugin
export default {"input":"Input_input__3vXNu","form":"Input_form__AaBxA","calculate":"Input_calculate__9R3JY","range":"Input_range__zUiq0","error":"Input_error__AS7Wn"};